import { EffectorData } from '../../../../../types/systems';
import { FieldRules, rules, runRules, ValidatedJsonType, ValidationResult } from '../validator';

export function isEffectorJson(value: ValidatedJsonType): ValidationResult {
	const json = value as EffectorData;

	const fields: FieldRules[] = [
		{ key: 'name', actual: json.name, rules: [rules.isString(json.name)] },
		{ key: 'expl_radius', actual: json.expl_radius, rules: [rules.isNumber(json.expl_radius)] },
		{
			key: 'indirect_fire',
			actual: json.indirect_fire,
			rules: [rules.optional(json.indirect_fire, rules.isBoolean(json.indirect_fire))],
		},
		{ key: 'side', actual: json.side, rules: [rules.isNumber(json.side)] },
		{ key: 'id', actual: json.id, rules: [rules.optional(json.id, rules.isNumber(json.id))] },
		{
			key: 'phit_distances',
			actual: json.phit_distances,
			rules: [
				rules.isObject(json.phit_distances),
				rules.custom(
					'dlong, dshort and dmedium must be strings',
					() =>
						typeof json.phit_distances === 'object' &&
						json.phit_distances !== null &&
						typeof (json.phit_distances as any).dlong === 'string' &&
						typeof (json.phit_distances as any).dshort === 'string' &&
						typeof (json.phit_distances as any).dmedium === 'string'
				),
			],
		},
		{
			key: 'phit_probabilities',
			actual: json.phit_probabilities,
			rules: [
				rules.isArray(json.phit_probabilities),
				rules.everyItem(
					json.phit_probabilities,
					'every item must have string dlong/dshort/dmedium and numeric target',
					(p: any) =>
						typeof p.dlong === 'string' &&
						typeof p.dshort === 'string' &&
						typeof p.dmedium === 'string' &&
						typeof p.target === 'number'
				),
			],
		},
		{
			key: 'pkill',
			actual: json.pkill,
			rules: [
				rules.isArray(json.pkill),
				rules.everyItem(
					json.pkill,
					'every item must have numeric target and string active/passive/none/reactive',
					(p: any) =>
						typeof p.target === 'number' &&
						typeof p.active === 'string' &&
						typeof p.passive === 'string' &&
						typeof p.none === 'string' &&
						typeof p.reactive === 'string'
				),
			],
		},
		{ key: 'fire_type', actual: json.fire_type, rules: [rules.isString(json.fire_type)] },
		{
			key: 'reload_time',
			actual: json.reload_time,
			rules: [rules.optional(json.reload_time, rules.isNumber(json.reload_time))],
		},
		{
			key: 'cost',
			actual: json.cost,
			rules: [rules.isString(json.cost), rules.noSpaces(json.cost)],
		},
	];

	return runRules(fields);
}

export const validateEffector = (data: ValidatedJsonType): ValidationResult => {
	return isEffectorJson(data);
};
